let RECEPTION_LIST_SEE_ALL = '全て見る >';

export default {
  RECEPTION_LIST_SEE_ALL,
};
